module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAB+SURBVAiZfY/BCYNAFETfX1OBBMR7mkgjn+3BgxD7CC5hIdiL5zSxJaQAwSw/B7MngwNzeTwGRsLjOSLScxSz4NqmHoD5QJvbph6cquZ1wRuk3RCkdcGrapYC7zFeKju9gPMPvbN8rreuSwCuiBswD+St5ov0NyFOfYjT7twXnrkq0cHGufAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/vector.png
// module id = 6kOh
// module chunks = 1